import { CompanyIntegrationStatus } from "@/components/integrations/company/company-integrations-sync";
import { Button } from "@/components/ui/button";
import { useTranslation } from "@/hooks/useTranslation";
import { CrmIntegrationProviderSupported } from "@shaarp/common";
import { Building2Icon, Loader2Icon } from "lucide-react";

type CreateNewCompanyProps = {
  integration: CompanyIntegrationStatus;
  onSync: (integrationKey: CrmIntegrationProviderSupported) => void;
};

export const CreateNewCompany = ({
  integration,
  onSync,
}: CreateNewCompanyProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex gap-4 items-center px-3 py-3 rounded-sm [&_svg]:size-4 [&_svg]:shrink-0">
      <img
        src={integration.logo}
        alt={integration.name}
        className="object-contain shrink-0 w-6 h-6"
      />
      <div className="flex flex-col flex-1 gap-1">
        <span className="text-sm font-medium">
          {t("company.integrations.createInIntegration", {
            integration: integration.name,
          })}
        </span>
        <span className="text-xs text-muted-foreground">
          {t("company.integrations.createNewCompany", {
            integration: integration.name,
          })}
        </span>
      </div>
      <Button
        variant="ghost"
        size="sm"
        disabled={integration.isLoading}
        onClick={() => onSync(integration.key)}
        className="p-0 w-8 h-8"
      >
        {integration.isLoading ? (
          <Loader2Icon className="w-4 h-4 animate-spin" />
        ) : (
          <Building2Icon className="w-4 h-4" />
        )}
      </Button>
    </div>
  );
};
